import XMarkIcon from "@heroicons/react/24/outline/XMarkIcon";
import ArrowRightIcon from "@heroicons/react/24/solid/ArrowRightIcon";
import { Dialog, Typography } from "@mui/material";
import { styled } from "@mui/styles";
import Color from "../../../assets/colors";

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-container .MuiPaper-root": {
    display: "flex",
    width: "100%",
    height: "fit-content",
    maxWidth: "700px",
    minHeight: "295px",
    flexDirection: "column",
    alignItems: "stretch",
    borderRadius: "24px",
    border: "1.5px solid var(--Primary-Black-One, #222)",
    background: "var(--Primary-White, #FFF)",

    "&:hover": {
      boxShadow: "2px 4px 10px 0px rgba(0, 0, 0, 0.12)",
    },

    [theme.breakpoints.down("sm")]: {
      maxWidth: "400px",
      minWidth: "330px",
    },
  },
}));

export const Header = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "16px 24px",
  borderBottom: `1px solid ${Color.grey}`,
});

export const TitleText = styled(Typography)(({ theme }) => ({
  "&&": {
    color: Color.textHighEmphasis,
    fontFamily: "Inter",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "24px",
  },

  [theme.breakpoints.down("sm")]: {
    "&&": {
      fontSize: "16px",
      lineHeight: "24px",
    },
  },
}));

export const CloseIcon = styled(XMarkIcon)({
  width: "24px",
  height: "24px",
  minWidth: "24px",
  minHeight: "24px",
  flexShrink: 0,
  cursor: "pointer",
});

export const Content = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  padding: "24px 32px 20px",

  [theme.breakpoints.down("sm")]: {
    padding: "15px 22px 13px",
  },
}));

export const BodyText = styled(Typography)(({ theme }) => ({
  "&&": {
    color: "var(--Text-Light-Theme-High-Emphasis, rgba(0, 0, 0, 0.87))",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.15px",

    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      lineHeight: "20px",
    },
  },
}));

export const Footer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "16px 30px",
  borderTop: `1px solid var(--Grey-Grey, #D8D8D8)`,

  [theme.breakpoints.down("sm")]: {
    padding: "16px 0px 10px",
    flexDirection: "column",
    alignItems: "stretch",
    gap: "5px",
  },
}));

export const SecondaryButton = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "transparent",
  border: 0,
  padding: "0px 24px",
  height: "auto",
  color: "var(--Text-Light-Theme-Medium-Emphasis, rgba(0, 0, 0, 0.60))",
  fontFamily: "Inter",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "17px",
  textDecoration: "underline",
  textUnderlinePosition: "from-font",

  [theme.breakpoints.down("sm")]: {
    width: "100%",
    padding: "12px 16px",
    order: 2,
  },
}));

export const PrimaryButton = styled("button")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  height: "42px",
  padding: "16px",
  borderRadius: "100px",
  border: 0,
  background: "var(--Primary-Black-Two, #353535)",
  color: "var(--Primary-White, #FFF)",
  cursor: "pointer",
  boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.08)",

  "&:hover": {
    background: "var(--Primary-Black-Three, #000000)",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.12)",
  },

  "&:active": {
    transform: "scale(0.95)",
  },

  "&:hover svg": {
    transform: "translateX(2px)",
  },

  [theme.breakpoints.down("sm")]: {
    width: "fit-content",
    order: 1,
    alignSelf: "center",
  },
}));

export const PrimaryButtonText = styled(Typography)({
  "&&": {
    color: "var(--Primary-White, #FFF)",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
  },
});

export const ArrowIcon = styled(ArrowRightIcon)({
  width: "18px",
  height: "18px",
  color: "var(--Primary-White, #FFF)",
  transition: "transform 0.2s ease",
});
